import { Component, OnInit } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { ServicesTypesService } from '../_services/services-types.service';
import { ServicesTypesDetailComponent } from '../services-types-detail/services-types-detail.component';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-services-types-list',
    templateUrl: './services-types-list.component.html',
    styleUrls: ['./services-types-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class ServicesTypesListComponent implements OnInit {
  public servicesTypes: any = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;


  constructor(
    private servicesTypesService: ServicesTypesService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public topbarService: TopbarService,
    
  ) {
    
    this.allowWrite = true;
    this.allowDelete = true;
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Tipos de servicios");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({});
    });
  }

  async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.servicesTypesService.all(params));
    this.servicesTypes = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(serviceType: any) {
    this.router.navigate(['servicesTypes/' + (serviceType && Object.keys(serviceType).length > 0 ? serviceType.id : 0)]);
  }

  delete(serviceType: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el tipo de servicio "+serviceType.name+"?",
        header: "Eliminar tipo de servicio",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.servicesTypesService.delete(serviceType.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Tipo de servicio eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }
}
